export const ADD_INVENTORY_PRODUCT_REQUEST = "ADD_INVENTORY_PRODUCT_REQUEST";
export const ADD_INVENTORY_PRODUCT_SUCCESS = "ADD_INVENTORY_PRODUCT_SUCCESS";
export const ADD_INVENTORY_PRODUCT_FAIL = "ADD_INVENTORY_PRODUCT_FAIL";

export const FETCH_INVENTORY_PRODUCT_REQUEST = "FETCH_INVENTORY_PRODUCT_REQUEST";
export const FETCH_INVENTORY_PRODUCT_SUCCESS = "FETCH_INVENTORY_PRODUCT_SUCCESS";
export const FETCH_INVENTORY_PRODUCT_FAIL = "FETCH_INVENTORY_PRODUCT_FAIL";

export const FETCH_INVENTORY_PRODUCT_ID_REQUEST = "FETCH_INVENTORY_PRODUCT_ID_REQUEST";
export const FETCH_INVENTORY_PRODUCT_ID_SUCCESS = "FETCH_INVENTORY_PRODUCT_ID_SUCCESS";
export const FETCH_INVENTORY_PRODUCT_ID_FAIL = "FETCH_INVENTORY_PRODUCT_ID_FAIL";

export const FETCH_INVENTORY_PRODUCT_STATUS_REQUEST = "FETCH_INVENTORY_PRODUCT_STATUS_REQUEST";
export const FETCH_INVENTORY_PRODUCT_STATUS_SUCCESS = "FETCH_INVENTORY_PRODUCT_STATUS_SUCCESS";
export const FETCH_INVENTORY_PRODUCT_STATUS_FAIL = "FETCH_INVENTORY_PRODUCT_STATUS_FAIL";

export const PRODUCT_ACTIVE_REQUEST = "PRODUCT_ACTIVE_REQUEST";
export const PRODUCT_ACTIVE_SUCCESS = "PRODUCT_ACTIVE_SUCCESS";
export const PRODUCT_ACTIVE_FAIL = "PRODUCT_ACTIVE_FAIL";

export const PRODUCT_INACTIVE_REQUEST = "PRODUCT_INACTIVE_REQUEST";
export const PRODUCT_INACTIVE_SUCCESS = "PRODUCT_INACTIVE_SUCCESS";
export const PRODUCT_INACTIVE_FAIL = "PRODUCT_INACTIVE_FAIL";

//update
export const PRODUCT_UPDATE_REQUEST = "PRODUCT_UPDATE_REQUEST";
export const PRODUCT_UPDATE_SUCCESS = "PRODUCT_UPDATE_SUCCESS";
export const PRODUCT_UPDATE_FAIL = "PRODUCT_UPDATE_FAIL";
export const PRODUCT_UPDATE_RESET = "PRODUCT_UPDATE_RESET";


//yasas

// src/constants/Inventory/productConstants.js
export const PRODUCT_CAT_REQUEST = "PRODUCT_CAT_REQUEST";
export const PRODUCT_CAT_SUCCESS = "PRODUCT_CAT_SUCCESS";
export const PRODUCT_CAT_FAIL = "PRODUCT_CAT_FAIL";
export const PRODUCT_CAT_RESET = "PRODUCT_CAT_RESET";